import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "../Logo/Logo";
import { BUILD_VERSION } from "../../../buildInfo";
import "./Footer.css";

const scrollTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

const Footer = () => {
  const { t } = useTranslation('common');
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-grid">

          {/* BRAND */}
          <div className="footer-section">
            <Link to="/" className="footer-brand" onClick={scrollTop} aria-label={t('ui.homeAria')}>
              <Logo variant="full" theme="dark" height={64} style={{ marginBottom: 6 }} />
              <span>{t('footer.tagline')}</span>
            </Link>

            <p className="footer-desc">
              {t('footer.description')}
            </p>

            <h4 className="footer-subtitle">{t('footer.followUs')}</h4>

            {/* SOCIAL ICONS */}
            <div className="social-logos">
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-logo" aria-label="Facebook">
                <img src="/icons/facebook.svg" alt="Facebook" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-logo" aria-label="Instagram">
                <img src="/icons/insta.svg" alt="Instagram" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="social-logo" aria-label="LinkedIn">
                <img src="/icons/Link.svg" alt="LinkedIn" />
              </a>
              <a href="https://x.com" target="_blank" rel="noreferrer" className="social-logo" aria-label="X">
                <img src="/icons/X.svg" alt="X" />
              </a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className="social-logo" aria-label="Youtube">
                <img src="/icons/yout.svg" alt="Youtube" />
              </a>
            </div>
          </div>

          {/* NAVIGATION */}
          <div className="footer-section">
            <h4 className="footer-subtitle">{t('footer.nav')}</h4>
            <Link className="footer-link" onClick={scrollTop} to="/">{t('nav.home')}</Link>
            <Link className="footer-link" onClick={scrollTop} to="/travels">{t('nav.trips')}</Link>
            <Link className="footer-link" onClick={scrollTop} to="/about">{t('nav.about')}</Link>
            <Link className="footer-link" onClick={scrollTop} to="/contact">{t('nav.contact')}</Link>
            <Link className="footer-link" onClick={scrollTop} to="/faq">{t('nav.faq')}</Link>
          </div>

          {/* LEGAL */}
          <div className="footer-section">
            <h4 className="footer-subtitle">{t('footer.legal')}</h4>
            <Link className="footer-link" onClick={scrollTop} to="/mentions-legales">{t('footer.mentions')}</Link>
            <Link className="footer-link" onClick={scrollTop} to="/privacy-policy">{t('footer.privacy')}</Link>
            <Link className="footer-link" onClick={scrollTop} to="/terms">{t('footer.terms')}</Link>
          </div>

          {/* CONTACT */}
          <div className="footer-section">
            <h4 className="footer-subtitle">{t('footer.contact')}</h4>

            <p className="footer-contact-label">{t('footer.email')}</p>
            <a href="mailto:contact@gowele.com" className="footer-link">
              contact@gowele.com
            </a>

            <p className="footer-contact-label">{t('footer.phone')}</p>
            <a href="tel:+33123456789" className="footer-link">
              +33 1 23 45 67 89
            </a>
          </div>

        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          {t('footer.copyright', { year })}
          {/* Marqueur de build : permet de vérifier qu'une version fraîche est en ligne. */}
          <span style={{ opacity: 0.5, fontSize: '0.75em', marginLeft: 8 }} title="Version de build">
            · build {BUILD_VERSION}
          </span>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
